import { render, staticRenderFns } from "./UpdateRules.vue?vue&type=template&id=2d57e6ed&scoped=true&"
import script from "./UpdateRules.vue?vue&type=script&lang=js&"
export * from "./UpdateRules.vue?vue&type=script&lang=js&"
import style0 from "./UpdateRules.vue?vue&type=style&index=0&id=2d57e6ed&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d57e6ed",
  null
  
)

export default component.exports